import React, { useEffect, useState } from 'react';
import { siteUrl } from '../../../shared/utils/siteUrl';
import './shop-cart.scss';

const ShopCart = props => {
    const { isLogIn } = props;

    const [quantiyProducts, setQuantiyProducts] = useState(0);
    const myCartLink = siteUrl + '/mis-puntos/mi-carrito'

    const hiddenShopCart = process.env.LOCALE === 'es-PE'|| process.env.LOCALE === 'es-PR'

    const handleRedirect = () => {
        if (!localStorage.getItem("TOKEN_INFO")) {
            sessionStorage.setItem('NEXT_PAGE', '/mis-puntos/mi-carrito');
            window.location.replace(siteUrl + '/login');
        }
        else
            window.location = myCartLink;
    }
    
    useEffect(() => {
        if (localStorage.getItem("TOKEN_INFO") && localStorage.getItem('USER_PRIZES')) {
            const prizes = JSON.parse(localStorage.getItem('USER_PRIZES'));
            setQuantiyProducts(
                prizes.reduce((num, item) => { return num + item.cantidad }, 0));
        }
    }, [])

    if(hiddenShopCart){
        return null
    }else{
        return (
            <div className="f-shopcart-position">
                <div className={"f-circle-shopcart " + (isLogIn ? "f-back-circum" : "")}>
                    <div className={"f-sub-circle-shopcart " + (isLogIn ? "f-back" : "")} />
                </div>
                <div className="f-shopcart">
                    <div className="f-quantiy-products">
                        <span className="f-quantiy-products-num">
                            {quantiyProducts}
                        </span>
                    </div>
                    <div onClick={()=> {
                            handleRedirect()
                        }} 
                        className="f-shopcart-container"
                    >
                        <span className="icon-cart f-icon" />
                        <p>Carrito</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default ShopCart;
